import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import './News.css';
import moment from "moment";

const useStyles = makeStyles( ( theme ) => ( {
    root: {
        position: 'relative',
        marginBottom: '2rem',
        marginTop: '3rem',
    },
    media: {
        minHeight: '5.5rem',
        height: '12rem',
        width: '100%',
        backgroundSize: '100% 100%',
        position: 'relative',
        '@media screen and (max-width: 1024px)': {
            height: '1rem',
        },
        boxShadow: "0 5px 10px grey",
    },
    title: {
        position: "relative",
        textAlign: "start",
        color: "#1D58A8",
        width: "100%",
        '@media screen and (max-width: 1300px)': {
            width: "90%",
            fontSize: 14,
        },
        '@media screen and (max-width: 1024px)': {
            width: "80%",
            fontSize: 13,
        },
        '@media screen and (max-width: 700px)': {
            fontSize: 12,
        },
        fontWeight: 900,
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: 16,
        textDecoration: 'none',
    },
    summary: {
        position: "relative",
        textAlign: "start",
        color: "#34455E",
        width: "100%",
        '@media screen and (max-width: 1300px)': {
            width: "90%",
            fontSize: 12,
        },
        '@media screen and (max-width: 1024px)': {
            width: "90%",
            fontSize: 11,
        },
        '@media screen and (max-width: 700px)': {
            fontSize: 10,
        },
        fontWeight: 900,
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: 14,
        textDecoration: 'none',
    },
    date: {
        position: "relative",
        textAlign: "start",
        color: "#34455E",
        fontWeight: 600,
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: 14,
        '@media screen and (max-width: 1024px)': {
            fontSize: 12,
        },
        '@media screen and (max-width: 700px)': {
            fontSize: 10,
        },
    }
} ) )

export default function BulkNewsElement ( { id, image, date, title, summary } )
{
    const classes = useStyles();
    const formattedDate = moment( date ).format( 'MMMM D, YYYY' )

    return (
        <div className={ classes.root }>
            <Grid container spacing={ 2 } alignItems="center" justify="center" >
                <Grid item xs={ 5 } sm={ 6 } md={ 5 }>
                    <a href={ `/news/${ id }` } >
                        <CardMedia
                            className={ classes.media }
                            component="div"
                            image={ `data:image/jpeg;base64, ${ image }` }
                        >
                        </CardMedia>
                    </a>
                </Grid>
                <Grid item xs={ 7 } sm={ 6 } md={ 7 } >
                    <Typography gutterBottom variant="subtitle2" className={ classes.date }>
                        { formattedDate }
                    </Typography>
                    <a href={ `/news/${ id }` } className={ classes.title } >
                        <Typography gutterBottom component="h2" className={ classes.title }>
                            { title }
                        </Typography>
                    </a>
                    <a href={ `/news/${ id }` } className={ classes.summary } >
                        <Typography gutterBottom component="h2" className={ classes.summary }>
                            { summary }
                        </Typography>
                    </a>
                </Grid>
            </Grid>
        </div >
    )
};